import { Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_POST, DBRequest, useConfig } from '../../api/api';
import { DocIcon } from './DocIcon';

// "War das hilfreich?" card — fire-and-forget, one vote per article remembered locally
export const FeedbackWidget = ({ slug }) => {
  const { t } = useTranslation();
  const config = useConfig();

  const storageKey = `documentation-feedback-${slug}`;
  const [voted, setVoted] = useState(() =>
    Boolean(localStorage.getItem(storageKey))
  );

  function handleVote(isHelpful) {
    if (voted) return;
    setVoted(true);
    localStorage.setItem(storageKey, isHelpful ? 'up' : 'down');
    DBRequest({
      config,
      path: `documentation/${slug}/feedback`,
      method: API_POST({ isHelpful }),
      onResponse: () => {},
    });
  }

  const voteButtonSx = (hoverColor, hoverBorder) => ({
    flex: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    border: '1px solid var(--border)',
    background: 'var(--panel2)',
    color: 'var(--text)',
    borderRadius: '8px',
    padding: '8px 0',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '12px',
    fontWeight: 600,
    ':hover': { borderColor: hoverBorder, color: hoverColor },
  });

  return (
    <Box
      sx={{
        border: '1px solid var(--border)',
        borderRadius: '12px',
        background: 'var(--panel)',
        padding: '16px',
      }}
    >
      <Box sx={{ fontSize: '12.5px', fontWeight: 600, marginBottom: '10px' }}>
        {t('Was this article helpful?')}
      </Box>
      {voted ? (
        <Box
          className="flex items-center"
          sx={{ gap: '7px', fontSize: '12px', color: 'var(--green)' }}
        >
          <DocIcon name="check_circle" size={17} />
          {t('Thank you for your feedback!')}
        </Box>
      ) : (
        <Box className="flex gap-2">
          <Box
            component="button"
            title={t('Yes')}
            onClick={() => handleVote(true)}
            sx={voteButtonSx('var(--green)', 'rgba(67,160,71,.5)')}
          >
            <DocIcon name="thumb_up" size={17} />
            {t('Yes')}
          </Box>
          <Box
            component="button"
            title={t('No')}
            onClick={() => handleVote(false)}
            sx={voteButtonSx('#c85050', 'rgba(200,80,80,.5)')}
          >
            <DocIcon name="thumb_down" size={17} />
            {t('No')}
          </Box>
        </Box>
      )}
    </Box>
  );
};
